import React from "react"

export const PostWrapper = ({ children }) => {
  return (
    <section className="mb-16 mx-auto px-6 max-w-5xl md:mb-24">
      {children}
    </section>
  )
}
